export const EMPLOYER_SHIFT_RATE_TYPES_FETCH_BEGIN = 'syftacp/EMPLOYER_SHIFT_RATE_TYPES_FETCH_BEGIN' as const
export const EMPLOYER_SHIFT_RATE_TYPES_FETCH_FAILED = 'syftacp/EMPLOYER_SHIFT_RATE_TYPES_FETCH_FAILED' as const
export const EMPLOYER_SHIFT_RATE_TYPES_FETCH_SUCCEEDED = 'syftacp/EMPLOYER_SHIFT_RATE_TYPES_FETCH_SUCCEEDED' as const
